<div *ngIf="news?.length" class="related-articles-container">
  <h4 *ngIf="!relatedArticleIds?.length" class="heading">⚡️ Im Trend</h4>
  <app-news-top class="embedded" *ngFor="let post of news; let i = index"
                [news]="post"
                [linkUtmParams]="positionalUTMParams(i + 1)">
  </app-news-top>
</div>
